import {
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import ReactMarkdown from "react-markdown";
import "../style/infoModal.css";
import packageJson from "../../package.json";
import { useRecoilValue } from "recoil";
import { configurationState } from "../state/state";

const InfoModal = (props: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  body: string;
}) => {
  const appConfig = useRecoilValue(configurationState);

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Heading variant="redDot">{props.title}</Heading>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody mb="4" className="infoModal">
          <ReactMarkdown>{props.body}</ReactMarkdown>
        </ModalBody>
        <ModalFooter>
          <Text>
            App Version: {packageJson.version} - Config Version:{" "}
            {appConfig.version}
          </Text>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default InfoModal;
